import { Injectable } from '@angular/core';
import { Prescription } from 'app/core/interfaces/prescriptions';
import { HttpClient } from '@angular/common/http';
import { environment } from 'app/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MedicationRequestService {
  constructor(private http: HttpClient) {}

  public create(params: Prescription) {
    return this.http.post(`${environment.apiUrl}/secretarias-medicationrequest`, params);
  }

  public update(id: string, params: Prescription) {
    return this.http.put(`${environment.apiUrl}/secretarias-medicationrequest/${id}`, params);
  }

  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-medicationrequest/${id}`);
  }

  public show(id: string) {
    return this.http.get<Prescription>(`${environment.apiUrl}/secretarias-medicationrequest/${id}`);
  }

  public showByEncounter(id: string) {
    return this.http.get<Prescription>(`${environment.apiUrl}/secretarias-medicationrequest/search_medicationrequest_by_encounter/${id}`);
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-medicationrequest`);
  }
}
